import React from "react";
import PropTypes from "prop-types";
import { Segment, Item } from "semantic-ui-react";
import { ItemData, Paginate } from "../../components";
import Link from "next/link";

const NhSavedLists = ({
  itemData,
  href,
  prev,
  active,
  header,
  getData,
  customclass,
  ...props
}) => {
  let data = itemData.length;
  let page_size = 3;
  let indexdata = (active - 1) * page_size;

  return (
    <Segment basic style={{ paddingLeft: 0 }}>
      {itemData && itemData.length !== 0 && (
        <Item.Group>
          {itemData
            .slice(indexdata)
            .slice(0, page_size)
            .map((item, index) => (
              <Item key={(Date.now() + item.npi + index).toString()}>
                <Link
                  href={"/Neighborhood/?id=" + item.id}
                  style={{ cursor: "pointer", marginRight: 20 }}
                  target="_blank"
                >
                  {/*<a style={{cursor:'pointer',marginRight: 20}} target="_blank"><Item.Image size='small' src={'/static/images/'+item.img_name}/></a>*/}
                  {/* <a
                    style={{ cursor: "pointer", marginRight: 20 }}
                    target="_blank"
                  > */}
                  <Item.Image
                    size="small"
                    src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/defaultnhmap.jpg`}
                  />
                  {/* </a> */}
                </Link>
                <Item.Content>
                  <Link
                    href={"/Neighborhood/?id=" + item.id}
                    style={{ cursor: "pointer" }}
                    target="_blank"
                  >
                    {/* <a style={{ cursor: "pointer" }} target="_blank"> */}
                    <Item.Header>
                      {item.name !== undefined ? item.name : "Not available"}
                    </Item.Header>
                    {/* </a> */}
                  </Link>
                  <Item.Description>
                    <p>NPI: {item.npi}</p>
                    <p>Value Index: {item.value}</p>
                    {/* <p>Best park in the peninsula.Most wonderful neighbours.</p> */}
                  </Item.Description>
                </Item.Content>
                {/*<ItemData
							key={index}
							href={href}
							size={item.size}
							source={'/static/images/'+item.img_name}
							head={item.neighborhood_name}
							subhead={item.subhead}
							desc={item.desc ? item.desc : null}
							extra={item.extra ? item.extra : null}
							header={header}
							customclass={customclass}
							onClick={e => getData?getData(e, item.head):e.preventDefault}
						/>*/}
              </Item>
            ))}
        </Item.Group>
      )}
      {itemData.length !== 0 && (
        <Paginate
          length={itemData.length}
          prev={prev}
          active={active}
          {...props}
        />
      )}
    </Segment>
  );
};

NhSavedLists.propTypes = {
  itemData: PropTypes.array.isRequired,
};

export default NhSavedLists;
